import {VanillaNumberValueCallback} from "../VanillaReader/VanillaReaderModel";

export class VanillaReaderUiLabelPageNumber {
     _hostDocument: Document;
    _pageNumberElement: HTMLElement;
    _pageNumberValueElement: HTMLElement;
    _progress: number = 0;

    _onPageNumberElementClickCallback: VanillaNumberValueCallback | undefined;

    _style = `
        <style>
            #vanilla-reader__label_page_number {
                min-width: 24px;
                min-height: 24px;
                max-width: 24px;
                max-height: 24px;
                text-align: center;
                color: var(--vanilla-reader__color__ui__foreground-dark);
                border: 2px;
                border-radius: 50%;
                border-color: transparent;
                border-style: solid;
                align-self: center;
                justify-content: center;
                transition: border 1s;
                margin: 0.5em;
            }
            
            #vanilla-reader__label_page_number__value {
                display: contents;
                font-variant: all-petite-caps;
                text-align: center;
                opacity: 0.8;
            }
            
            @media (min-width: 480px) {
                #vanilla-reader__label_page_number {
                    display: none;
                }
            }
            
            @media (orientation: landscape) {
                #vanilla-reader__label_page_number {
                    display: none;
                }
            }
        </style>`;

    _template = `
        <div aria-hidden="true" id="vanilla-reader__label_page_number">
            <span id="vanilla-reader__label_page_number__value"></span>
        </div>`;

    constructor(private _hostElement: HTMLElement, insertPosition: InsertPosition = 'beforeend') {
        this._hostDocument = _hostElement.ownerDocument!;
        this._hostElement.insertAdjacentHTML(insertPosition, this._template);
        this._hostElement.insertAdjacentHTML('afterbegin', this._style);

        this._pageNumberElement = this._hostDocument.getElementById('vanilla-reader__label_page_number')!;
        this._pageNumberValueElement = this._hostDocument.getElementById('vanilla-reader__label_page_number__value')!;

        this._pageNumberValueElement.addEventListener('click', this._onPageNumberElementClick);
    }

    public get value(): string {
        return this._pageNumberValueElement.innerHTML;
    }

    public set value(value:string) {
        this._pageNumberValueElement.innerHTML = value;
    }

    public get progress(): number {
        return this._progress;
    }

    public set progress(value: number) {
        this._progress = value;
        this._applyProgress(value);
    }

    onClick(callback: VanillaNumberValueCallback): void {
        this._onPageNumberElementClickCallback = callback;
    }

    /**
     *
     * PRIVATE METHOD
     *
     * */

    _onPageNumberElementClick = () => {
        if(this._onPageNumberElementClickCallback) {
            this._onPageNumberElementClickCallback(parseInt(this.value));
        }
    }

    _applyProgress(value: number): void {
        this._pageNumberElement.style.borderColor = 'transparent';
        this._pageNumberElement.style.borderWidth = '1px';
        this._pageNumberElement.style.borderRadius = '50%';
        this._pageNumberElement.style.borderStyle = 'solid';

        this._pageNumberElement.style.borderTopWidth = '1px';
        this._pageNumberElement.style.borderTopColor = '#b3b3b3';

        if (value >= 25) {
            this._pageNumberElement.style.borderRightWidth = '1px';
            this._pageNumberElement.style.borderRightColor = '#b3b3b3';
        }

        if (value >= 50) {
            this._pageNumberElement.style.borderBottomWidth = '1px';
            this._pageNumberElement.style.borderBottomColor = '#b3b3b3';
        }

        if (value >= 75) {
            this._pageNumberElement.style.borderLeftWidth = '1px';
            this._pageNumberElement.style.borderLeftColor = '#b3b3b3';
        }
    }
}
